// API for interacting with localStorage and sessionStorage

// Auth

const PARTNER_AUTH_TOKEN_KEY = 'partner-portal-token'
const SCHOOL_AUTH_TOKEN_KEY = 'school-portal-token'
const ARTIST_AUTH_TOKEN_KEY = 'artist-portal-token'

export function getPartnerAuthToken() {
  return getItem(PARTNER_AUTH_TOKEN_KEY)
}

export function setPartnerAuthToken(token, persist = true) {
  return setItem(PARTNER_AUTH_TOKEN_KEY, token, persist)
}

export function clearPartnerAuthToken() {
  return removeItem(PARTNER_AUTH_TOKEN_KEY)
}

export function getSchoolAuthToken() {
  return getItem(SCHOOL_AUTH_TOKEN_KEY)
}

export function setSchoolAuthToken(token, persist = true) {
  return setItem(SCHOOL_AUTH_TOKEN_KEY, token, persist)
}

export function clearSchoolAuthToken() {
  return removeItem(SCHOOL_AUTH_TOKEN_KEY)
}

// Teaching Artist Auth Token
export function getArtistAuthToken() {
  return getItem(ARTIST_AUTH_TOKEN_KEY)
}

export function setArtistAuthToken(token, persist = true) {
  return setItem(ARTIST_AUTH_TOKEN_KEY, token, persist)
}

export function clearArtistAuthToken() {
  return removeItem(ARTIST_AUTH_TOKEN_KEY)
}

// Learning Hub course preview

const PREVIEW_COURSE_ID_KEY = 'learning-hub-preview-course-id'
const PREVIEW_TOKEN_KEY = 'learning-hub-preview-token'

export function getPreviewCourseId() {
  return getItem(PREVIEW_COURSE_ID_KEY)
}

export function setPreviewCourseId(id) {
  return setItem(PREVIEW_COURSE_ID_KEY, id)
}

export function clearPreviewCourseId() {
  return removeItem(PREVIEW_COURSE_ID_KEY)
}

export function getPreviewToken() {
  return getItem(PREVIEW_TOKEN_KEY)
}

export function setPreviewToken(token) {
  return setItem(PREVIEW_TOKEN_KEY, token)
}

export function clearPreviewToken() {
  return removeItem(PREVIEW_TOKEN_KEY)
}

// Clear all auth tokens across portals
export function clearAllAuthTokens() {
  clearPartnerAuthToken()
  clearSchoolAuthToken()
  clearArtistAuthToken()
  clearPreviewCourseId()
  clearPreviewToken()
}

// Replace whichever portal token is active (exactly one after sign-in) without clearing storage for others
export function replaceActivePortalAuthToken(token) {
  if (localStorage.getItem(SCHOOL_AUTH_TOKEN_KEY) != null) {
    setSchoolAuthToken(token, true)
  } else if (localStorage.getItem(PARTNER_AUTH_TOKEN_KEY) != null) {
    setPartnerAuthToken(token, true)
  } else if (localStorage.getItem(ARTIST_AUTH_TOKEN_KEY) != null) {
    setArtistAuthToken(token, true)
  }
}

// Current artist Id

const ARTIST_ID_KEY = 'current-artist-id'

export function getCurrentArtistId() {
  return getItem(ARTIST_ID_KEY)
}

export function setCurrentArtistId(id) {
  return setItem(ARTIST_ID_KEY, id)
}

export function clearCurrentArtistId() {
  return removeItem(ARTIST_ID_KEY)
}

// Current partner Id

const PARTNER_ID_KEY = 'current-partner-id'

export function getCurrentPartnerId() {
  return getItem(PARTNER_ID_KEY)
}

export function setCurrentPartnerId(id) {
  return setItem(PARTNER_ID_KEY, id)
}

export function clearCurrentPartnerId() {
  return removeItem(PARTNER_ID_KEY)
}

// Current school id

const SCHOOL_ID_KEY = 'current-school-id'

export function getCurrentSchoolId() {
  return getItem(SCHOOL_ID_KEY)
}

export function setCurrentSchoolId(id) {
  return setItem(SCHOOL_ID_KEY, id)
}

export function clearCurrentSchoolId() {
  return removeItem(SCHOOL_ID_KEY)
}

// Admin

const ADMIN_KEY = 'admin'

export function getIsAdmin() {
  return getItem(ADMIN_KEY)
}

export function setIsAdmin(id) {
  return setItem(ADMIN_KEY, id)
}

export function clearIsAdmin() {
  return removeItem(ADMIN_KEY)
}

// SSO

const SSO_REDIRECT_KEY = 'sso-redirect'

export function getSsoRedirect() {
  return getItem(SSO_REDIRECT_KEY)
}

export function setSsoRedirect(url) {
  return setItem(SSO_REDIRECT_KEY, url)
}

export function clearSsoRedirect() {
  return removeItem(SSO_REDIRECT_KEY)
}

/* HELPERS */

// Get item from localStorage, falling back to session storage
function getItem(key) {
  const item = localStorage.getItem(key) || sessionStorage.getItem(key)

  try {
    return JSON.parse(item)
  } catch (e) {
    return item
  }
}

// Set item in local storage, or session storage if specified
function setItem(key, value, persist = true) {
  const stringifiedValue = JSON.stringify(value)
  return persist
    ? localStorage.setItem(key, stringifiedValue)
    : sessionStorage.setItem(key, stringifiedValue)
}

// Remove item from local storage and session storage
function removeItem(key) {
  localStorage.removeItem(key)
  sessionStorage.removeItem(key)
}
